import { __, sprintf, _n } from '@wordpress/i18n';
import {
	PanelBody,
	RangeControl,
	CheckboxControl,
	__experimentalUnitControl as UnitControl,
} from '@wordpress/components';

const Behaviors = ( props ) => {
	const { attributes, setAttributes } = props;
	const { triggers, settings } = attributes;

	const changeAttribute = ( triggerName, triggerType, val ) => {
		setAttributes( {
			settings: {
				...settings,
				[ triggerName ]: { [ triggerType ]: val },
			},
		} );
	};

	const handleChangeBehaviors = ( trigger, val ) => {
		let filteredArray = [];
		if ( val ) {
			filteredArray = [ ...triggers, trigger ];
		} else {
			filteredArray = triggers.filter( ( item ) => item !== trigger );
		}
		setAttributes( {
			triggers: filteredArray,
		} );
	};

	const units = [
		{ value: 'd', label: 'days', default: 1 },
		{ value: 'h', label: 'hours', default: 10 },
		{ value: 'm', label: 'minutes', default: 30 },
	];

	return (
		<PanelBody initialOpen={ true } title={ __( 'Behaviors', 'popper' ) }>
			<CheckboxControl
				label={ __( 'Open after X pageviews', 'popper' ) }
				checked={ triggers.includes( 'pageviews' ) }
				onChange={ ( val ) => {
					handleChangeBehaviors( 'pageviews', val );
					if ( val && ! settings.pageviews?.pageNum ) {
						changeAttribute( 'pageviews', 'pageNum', 5 );
					}
				} }
				help={ __(
					'Open only if visitor has visited X page(s)',
					'popper'
				) }
				__nextHasNoMarginBottom
			/>
			{ triggers?.includes( 'pageviews' ) && (
				<RangeControl
					label={ __( 'Number of pages', 'popper' ) }
					help={ __(
						'Show the popup when this number of pages has been visited.'
					) }
					beforeIcon="visibility"
					value={ settings.pageviews?.pageNum || '' }
					onChange={ ( val ) =>
						changeAttribute( 'pageviews', 'pageNum', val )
					}
					min={ 1 }
					max={ 50 }
					__nextHasNoMarginBottom
					__next40pxDefaultSize
				/>
			) }
			<CheckboxControl
				label={ __( 'Dismiss for Recurrent Visitors', 'popper' ) }
				checked={ triggers.includes( 'dismissForVisitors' ) }
				onChange={ ( val ) => {
					handleChangeBehaviors( 'dismissForVisitors', val );
					if ( val && ! settings.dismissForVisitors?.period ) {
						changeAttribute( 'dismissForVisitors', 'period', 1 );
					}
				} }
				help={ __(
					'Do not show the campaign again for current session',
					'popper'
				) }
				__nextHasNoMarginBottom
			/>
			{ triggers.includes( 'dismissForVisitors' ) && (
				<UnitControl
					onChange={ ( val ) =>
						changeAttribute( 'dismissForVisitors', 'period', val )
					}
					help={ __(
						'Do not show the campaign again for X time',
						'popper'
					) }
					value={ settings.dismissForVisitors?.period }
					units={ units }
					__next40pxDefaultSize
				/>
			) }
		</PanelBody>
	);
};

export default Behaviors;
